// ═══════════════════════════════════════════════════════════════════════════════
//  src/components/onboarding/onboardingLabels.js
//  Traduce los valores del payload (slugs) a las etiquetas legibles que el copy
//  de la Pantalla 7 inyecta en sus [placeholders].
//
//  Existe para que Screen7_Revelacion y ReturnSummary compartan exactamente las
//  mismas etiquetas: el documento (§7.3) exige que la vista resumen reutilice
//  "tal cual" el copy ya aprobado de 7.2, no una variante.
// ═══════════════════════════════════════════════════════════════════════════════

import {
  ASPIRATIONS,
  CONTEXTS,
  PAST_ATTEMPTS,
  PERCEIVED_LEVELS,
  TRAINING_INTENSITIES,
  FEEDBACK_STYLES,
  CUSTOM_OPTION,
} from './onboardingContent';

const find = (list, value, key, fallback) =>
  list.find((x) => x.value === value)?.[key] ?? fallback;

export function buildLabels(payload) {
  // Si el usuario eligió "Otro objetivo distinto..." y escribió su meta, el copy
  // de la Pantalla 7 debe hablar de ESA meta, no de un genérico. Es el único
  // punto donde una etiqueta sale de texto que escribió el propio usuario.
  const aspirationLabel =
    payload.aspiration === CUSTOM_OPTION && payload.aspiration_custom
      ? payload.aspiration_custom
      : find(ASPIRATIONS, payload.aspiration, 'short', 'tu objetivo');

  return {
    aspirationLabel,
    contextLabel: find(CONTEXTS, payload.context_type, 'short', 'tu contexto'),
    contextProcessing: find(CONTEXTS, payload.context_type, 'processing', 'tu contexto'),
    attemptsLabel: find(PAST_ATTEMPTS, payload.past_attempts, 'short', 'otros métodos'),
    perceivedLabel: find(PERCEIVED_LEVELS, payload.perceived_level, 'display', 'otro nivel'),
    intensityLabel: find(TRAINING_INTENSITIES, payload.training_intensity, 'short', 'tu ritmo'),
    feedbackLabel: find(FEEDBACK_STYLES, payload.feedback_style, 'short', 'tu estilo'),

    // [X] del espejo (§7.2 a). Sale del CEFR estimado por la calibración; es
    // null cuando el alumno tomó la bifurcación de "cero absoluto" y no la hizo.
    realLevel: payload.calibration_detail?.estimated_cefr ?? null,
  };
}
